module.exports = __webpack_public_path__ + "static/img/contus2-E5up-mG9.fde41e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/contus2-E5up-mG9.png
// module id = BcJO
// module chunks = 16